module.exports = __webpack_public_path__ + "static/media/alert-white.fa5152e0.svg";